var video = document.getElementsByClassName('video')[0];

// Add an event listener to the video to loop it
video.addEventListener('ended', function() {
this.currentTime = 0;
this.play();
}, false);

// Start the video
video.play();

// Stop the video on exit
window.addEventListener('beforeunload', function() {
    video.pause();
    video.currentTime = 0;
  });